const ChevronUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    {...props}>
    <path
      d='M9 6.22266L4.5 10.7227L5.5575 11.7802L9 8.34516L12.4425 11.7802L13.5 10.7227L9 6.22266Z'
      fill='currentColor'
    />
  </svg>
);

export default ChevronUpIcon;
